export default __webpack_public_path__ + "static/media/G0860.Breech_semirecum_delay2.1692880500000.704dc8f7.jpg";